"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTable = DataTable;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
function getPageRange(current, total) {
    var siblings = 1;
    var boundary = 1;
    var totalSlots = boundary * 2 + siblings * 2 + 3;
    if (total <= totalSlots) {
        return Array.from({ length: total }, function (_, i) { return i + 1; });
    }
    var leftSibling = Math.max(current - siblings, boundary + 2);
    var rightSibling = Math.min(current + siblings, total - boundary - 1);
    var showLeftEllipsis = leftSibling > boundary + 2;
    var showRightEllipsis = rightSibling < total - boundary - 1;
    var pages = [];
    for (var i = 1; i <= boundary; i++)
        pages.push(i);
    if (showLeftEllipsis)
        pages.push("…");
    else
        for (var i = boundary + 1; i < leftSibling; i++)
            pages.push(i);
    for (var i = leftSibling; i <= rightSibling; i++)
        pages.push(i);
    if (showRightEllipsis)
        pages.push("…");
    else
        for (var i = rightSibling + 1; i <= total - boundary; i++)
            pages.push(i);
    for (var i = total - boundary + 1; i <= total; i++)
        pages.push(i);
    return pages;
}
function DataTable(props) {
    var columns = props.columns, data = props.data, _a = props.isLoading, isLoading = _a === void 0 ? false : _a, _b = props.emptyContent, emptyContent = _b === void 0 ? "No data found" : _b, _c = props.page, page = _c === void 0 ? 1 : _c, _d = props.totalPages, totalPages = _d === void 0 ? 1 : _d, onPageChange = props.onPageChange, sortColumn = props.sortColumn, sortDirection = props.sortDirection, onSortChange = props.onSortChange, _e = props.selectionMode, selectionMode = _e === void 0 ? "none" : _e, selectedKeys = props.selectedKeys, onSelectionChange = props.onSelectionChange, onRowClick = props.onRowClick;
    var handleSortChange = (0, react_2.useCallback)(function (descriptor) {
        if (onSortChange && descriptor.column && descriptor.direction) {
            onSortChange(descriptor.column, descriptor.direction);
        }
    }, [onSortChange]);
    var sortDescriptor = (0, react_2.useMemo)(function () {
        if (sortColumn && sortDirection) {
            return { column: sortColumn, direction: sortDirection };
        }
        return undefined;
    }, [sortColumn, sortDirection]);
    // Ensure each item has an `id` property for HeroUI's internal collection
    var tableItems = (0, react_2.useMemo)(function () { return data.map(function (item, index) { return (__assign(__assign({}, item), { id: item._id || "row-".concat(index) })); }); }, [data]);
    var renderCell = (0, react_2.useCallback)(function (item, columnKey, index) {
        var column = columns.find(function (c) { return c.key === columnKey; });
        if (!column)
            return null;
        if (column.render) {
            return column.render(item, index);
        }
        // Default rendering - access the value by key
        var value = item[columnKey];
        if (value === null || value === undefined)
            return "-";
        if (typeof value === "object")
            return JSON.stringify(value);
        return String(value);
    }, [columns]);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(react_1.Table, { "aria-label": "Data table", isHeaderSticky: true, sortDescriptor: sortDescriptor, onSortChange: handleSortChange, selectionMode: selectionMode, selectedKeys: selectedKeys, onSelectionChange: onSelectionChange, classNames: {
                    wrapper: "min-h-[400px]",
                }, removeWrapper: false, children: [(0, jsx_runtime_1.jsx)(react_1.TableHeader, { columns: columns, children: function (column) { return ((0, jsx_runtime_1.jsx)(react_1.TableColumn, { allowsSorting: column.sortable, width: column.width, align: column.align, children: column.label }, column.key)); } }), (0, jsx_runtime_1.jsx)(react_1.TableBody, { items: tableItems, isLoading: isLoading, loadingContent: (0, jsx_runtime_1.jsx)(react_1.Spinner, { label: "Loading..." }), emptyContent: emptyContent, children: function (item) { return ((0, jsx_runtime_1.jsx)(react_1.TableRow, { className: onRowClick ? "cursor-pointer hover:bg-default-100" : "", onClick: function () { return onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(item); }, children: function (columnKey) {
                                var index = columns.findIndex(function (c) { return c.key === columnKey; });
                                return (0, jsx_runtime_1.jsx)(react_1.TableCell, { children: renderCell(item, columnKey, index) }, columnKey);
                            } }, item.id)); } })] }), onPageChange && totalPages > 1 && ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between py-4", children: [(0, jsx_runtime_1.jsxs)("span", { className: "text-small text-default-400", children: ["Page ", page, " of ", totalPages] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-1", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "flat", isDisabled: page <= 1, onPress: function () { return onPageChange(page - 1); }, children: "\u2039" }), getPageRange(page, totalPages).map(function (p, i) {
                                return p === "…" ? ((0, jsx_runtime_1.jsx)("span", { className: "px-2 text-default-400 select-none", children: "\u2026" }, "ellipsis-".concat(i))) : ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: p === page ? "solid" : "flat", color: p === page ? "primary" : "default", onPress: function () { return onPageChange(p); }, children: p }, p));
                            }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "flat", isDisabled: page >= totalPages, onPress: function () { return onPageChange(page + 1); }, children: "\u203A" })] })] }))] }));
}
